<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb noprint">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"> <i class="fa fa-suitcase" aria-hidden="true"></i> CONTRATOS SEM IPV6</li>
                </ol>

                <div class="row">
                    <div class="col-md-12">
                        <div>
                            <div class="col-md-7 noprint">
                                <label class="control-label">BUSCA POR NOME DO CLIENTE</label>
                                <input type="text" v-model="nome" class="form-control" >
                            </div>

                            <div class="col-md-5 noprint">
                                <br/>
                                <blockquote class="blockquote-reverse">
                                    Total de Contratos: <b>{{ getContratos.length }}</b>
                                </blockquote>
                            </div>

                            <div class="col-md-12" style="margin-top: 20px">

                                <button class="btn-danger btn btn-xs noprint" type="button" @click="print()">
                                    <i class="fa fa-print" aria-hidden="true"></i> IMPRIMIR
                                </button><br/>

                                <table id="mytable" class="table table-bordred ">

                                    <thead>
                                        <tr>
                                            <th>CLIENTE</th>
                                            <th style="text-align: center;width: 100px">IP</th>
                                            <th style="text-align: center;width: 100px">TIPO</th>
                                            <th style="text-align: center;width: 140px" class="noprint">AÇÕES</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr v-for="r in getContratos" v-bind:key="r._id">
                                            <td>
                                                <b>{{ r.cliente.nome }}</b><br/>
                                                <i>{{ r.obs_ipv6 }}</i>
                                                <div v-if="r.cliente._id === true">
                                                    <br/><textarea class="form-control" v-model="obs"></textarea><br/>
                                                    <button @click="save(r)" class="btn btn-success btn-xs">
                                                        SALVAR OBS <i class="fa fa-save" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                {{ r.radio.ip }}
                                            </td>
                                            <td class="text-center">
                                                <i>{{ r.tipo }}</i>
                                            </td>
                                            <td class="noprint text-center">
                                                <a :href="'#/contrato/add/' + r._id" class="btn btn-primary btn-xs">
                                                    ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                                </a>
                                                <button @click="open(r)" class="btn btn-warning btn-xs">
                                                    OBS <i class="fa fa-edit" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Contratos } from "../../class/index";

export default {
    data() {
        return {
            contratos: [],
            user: null,
            nome: null,
            obs: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }
            return this.contratos.filter(player => {
                return player.cliente.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadByContrato();
    },
    methods: {
        async loadByContrato() {
            this.contratos = await Contratos.allNoIPV6();
        },
        open(r) {
            r.cliente._id = true;
        },
        save(r) {
            Contratos.saveObsNoIPV6(this.obs, r._id)
                .then(() => {
                    r.obs_ipv6 = String(this.obs);
                    r.cliente._id = null;
                    this.obs = null;
                })
                .catch(err => console.log(err));
        },
        print() {
            window.print();
        }
    }
};
</script>
